import React from 'react';
import PropTypes from 'prop-types';

const ImageIconWrapper = ({ src, ...rest }) => {
  return <img src={src} alt="icon" {...rest} />;
};

ImageIconWrapper.propTypes = {
  src: PropTypes.string.isRequired,
};

ImageIconWrapper.type = {
  magnifiedDocument: '/images/magnified-document.svg',
  checkmarkGreen: '/images/checkmark-green.svg',
  alertGreenBell: '/images/green-alert-bell.svg',
  errorEscalation: '/images/error-esclamation.svg',
  xGreen: '/images/x-green.svg',
};

export default ImageIconWrapper;
